import React, { Component, useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import CatGrid from '../CatGrid';
import CatPanel from '../CatPanel';
import CourseForm from '../course/CourseForm';
import RootForm from './RootForm';
import { useTranslation } from 'react-i18next';

function RootPane(props) {
  const {t} = useTranslation();
  const catAdded = (cat)=>{props.catAdded(cat)};
  const catChanged = (cat)=>{props.catChanged(cat)};
  const catDeleted = (cat)=>{props.catDeleted(cat)};
  const openPage = (cat)=>{props.selectionChanged(cat)};
  const refresh = ()=>{props.refresh()};

  const renderForm = (cat,onChange)=>{
    if(!props.cat.parentGroup)
      return <CourseForm cat={cat} onChange={onChange}/>;
    else
      return <RootForm cat={cat} onChange={onChange}/>;
  } 

  var childCatType = props.cat.parentGroup?'ROOT':'COURSE';
  var tabLabel = props.cat.id==0?t('Programs'):(props.cat.parentGroup?t('Groups'):t('Courses'));

  return(
  <React.Fragment>
  <CatPanel cat={props.cat} openPage={openPage}/>
  <TabView>
  <TabPanel  header={tabLabel} headerClassName="text-bold">
    <CatGrid parentCat={props.cat} 
      mode="CHILD"
      catType={childCatType}
      catAdded={catAdded} 
      catChanged={catChanged} 
      catDeleted={catDeleted}
      refresh={refresh}
      openPage={openPage}
      form={renderForm}
      />
  </TabPanel>
  {props.cat.id!=0?
  <TabPanel  header={t("Competencies")} headerClassName="text-bold">
    <CatGrid parentCat={props.cat} 
      mode="CHILD"
      catType="COMP"
      catAdded={catAdded} 
      catChanged={catChanged} 
      catDeleted={catDeleted}
      openPage={openPage}
      />
  </TabPanel>:<></>
  }
  </TabView>
  </React.Fragment>
	)
}

export default RootPane;
